// extracted by mini-css-extract-plugin
export default {"Container":"Resources_Container__iVo8K","wrapper":"Resources_wrapper__sUFYW"};